import { HTMLProps } from 'react';

export const NavDailyRatesMonth: React.FC<
    { monthData: number[]; amountOfRows: number; monthName: string } & HTMLProps<HTMLDivElement>
> = ({ monthData, amountOfRows, monthName, className }) => {
    const splitData = (oldData: number[], subsetLength: number) => {
        let newData: number[][] = [];
        let temporaryData: number[] = [];
        oldData.forEach((element, index) => {
            temporaryData = [...temporaryData, element];
            if (((index + 1) % subsetLength === 0 && index !== 0) || index === oldData.length - 1) {
                newData = [...newData, temporaryData];
                temporaryData = [];
            }
        });
        return newData;
    };
    const newData = splitData(monthData, amountOfRows);
    return (
        <div className={`flex flex-col ${className}`}>
            <span className="flex justify-start text-lg font-medium mb-4 ml-1">{monthName}</span>
            <div className="flex flex-1 flex-row justify-between items-start">
                {newData.map((dataColumn, columnIndex) => {
                    return (
                        <div className="flex flex-1 flex-col border-2 border-black m-1" key={columnIndex}>
                            {dataColumn.map((dataRow, rowIndex) => {
                                return (
                                    <div
                                        className="flex-1 flex flex-row border-b border-gray-400"
                                        key={`${rowIndex} ${columnIndex}`}
                                    >
                                        <span className="flex justify-center px-2 py-1 bg-white border-r border-gray-400 font-medium w-8">
                                            {1 + rowIndex + columnIndex * amountOfRows}
                                        </span>
                                        <span className="flex flex-1 justify-center py-1 bg-gray-100">
                                            {dataRow === -1
                                                ? '-'
                                                : dataRow.toLocaleString('nl-NL', {
                                                      minimumFractionDigits: 2,
                                                      maximumFractionDigits: 2,
                                                  })}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
